import { memo } from 'react';

import { ImagesIcon, RotateCwIcon } from '@air/design-icons';

import { ASSET_MODAL_PROCESSING_TEXT } from '~/constants/testIDs';

type NoPreviewVisualizerProps = {
  isProcessing?: boolean;
};

export const NoPreviewVisualizer = memo(({ isProcessing }: NoPreviewVisualizerProps) => {
  return (
    <div data-testid={ASSET_MODAL_PROCESSING_TEXT} className="flex flex-col items-center justify-center">
      {isProcessing ? (
        <RotateCwIcon size="xl" className="animate-spin ads:text-icon-subtle text-gray-9 motion-reduce:animate-none" />
      ) : (
        <ImagesIcon size={64} className="ads:text-icon-subtle text-gray-9" />
      )}
      <div className="mt-4 text-center ads:text-secondary text-14 text-gray-11 md:mt-6 md:text-16">
        {isProcessing ? 'Processing... this may take a few minutes' : 'No preview available'}
      </div>
    </div>
  );
});

NoPreviewVisualizer.displayName = 'NoPreviewVisualizer';
